import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable, finalize } from 'rxjs';
import { LoadingService } from './loading.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private readonly loading: LoadingService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const url = (req.url ?? '').toString();

    // Avoid showing global loading for local static assets.
    const isAssetRequest =
      url.includes('/assets/') ||
      url.startsWith('assets/') ||
      /\.(svg|png|jpg|jpeg|gif|webp|ico)$/i.test(url);

    if (isAssetRequest) {
      return next.handle(req);
    }

    this.loading.start();
    return next.handle(req).pipe(finalize(() => this.loading.stop()));
  }
}
